import { AppName } from '@pflegia/types/api/general/app-name';
import { SourceDomain } from '@pflegia/types/api/source-domain/source-domain';

export const getAppNameFromDomain = (sourceDomain?: SourceDomain) => {
  switch (sourceDomain) {
    case SourceDomain.PflegiaDe:
    case SourceDomain.PflegiaAt:
      return AppName.Pflegia;
    case SourceDomain.PraxiaDe:
      return AppName.Praxia;
    case SourceDomain.DociaDe:
      return AppName.Docia;
    default:
      return AppName.Pflegia;
  }
};
